// noinspection JSUnusedGlobalSymbols

import {Nullable} from "./caos-def";


export function replaceAll(string: string, find: string, replace: string): string {
    return string.replace(new RegExp(escapeRegExp(find), "g"), replace);
}

/**
 * Escapes a string for use in regex as a literal
 * @param string
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#escaping
 */
export function escapeRegExp(string: string): string {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
}

/**
 * Checks if a string is null or blank
 * @param value
 */
export function isBlankOrNull(value: Nullable<string>): boolean {
    if (value == null) {
        return true;
    }
    return value.trim().length === 0;
}


/**
 * Checks that a string is NOT null or blank.
 * @param value
 */
export function isNotBlankOrNull(value: Nullable<string>): value is Exclude<string, null>  {
    if (value == null) {
        return false;
    }
    return (value.trim().length > 0);
}

// noinspection SpellCheckingInspection
export function nltobr(string: string): string {
    return replaceAll(string, "\n", "<br/>");
}


export const camelToSnakeCase: (string: string) => string = implodeCamelCase("_")

export const camelToKabobCase: (string: string) => string = implodeCamelCase("-")


const upperCaseRegex = /([A-Z])/g;

function implodeCamelCase(delimiter: string): (string:string) => string {
    return (string:string) => {
        return string.replace(upperCaseRegex, delimiter + "$1").toLowerCase();
    }
}